import NumberController from "csi/heading/NumberController";
import declare from "dojo/_base/declare";

const OrientationController = declare(NumberController, {
	/**
	 * @override
	 * Make sure Orientation is not higher than 360 or lower than 0
	 */
	process() {
		this.newValue = Math.min(Math.max(0, this.newValue as number), 360);
		this.inherited(arguments);
	},
});

export = OrientationController;
